export const APP_USER = "68315ee3824a3950cbfe5e62";
export const ADMIN_ROLE = "683146643e539a67f61e7cf8";

export const MASTER_ROLE = "68bbaca58f813b84605d19e8";
export const CORDINATOR_ROLE = "68bbaca08f813b84605d19e7";
export const REGIONAL_PRINCIPAL_ROLE = "68bbac988f813b84605d19e6";
export const SUPERVISOR_ROLE = "683146643e539a67f61e7cf8";
export const ASESOR_ROLE = "683146783e539a67f61e7cf9";
export const GENERAL_PRINCIPAL_ROLE = "68bc8a3c8f813b84605d1a01";
export const ASESOR_CIERRE_ROLE = "6893a765b7d34b7f0bb3bbd2";
